export const IMAGE_SIZE_MOBILE = '150px';
export const IMAGE_SIZE_DESKTOP = '250px';
